import { styled } from '@mui/material';

export const PageW = styled('div')`
  padding: 64px 0px 40px 38px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1023px) {
    padding: 64px 16px 0px 16px;
  }
`;

export const ContentWrapper = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
`;
